// @ts-nocheck
import React, { useState } from 'react';
import AgregarDifusion from './AgregarDifusion';
import { ModalGeneral } from '../../../Componentes/ModalGeneral';
import Fab from '@mui/material/Fab';
import Tooltip from '@mui/material/Tooltip';
import anadirIcono from '../../../Iconos/anadir_difusion.png';

export function AgregarDifusionButton() {
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <Tooltip title="Crear Difusión">
        <Fab
          sx={{
            backgroundColor: "#B71234",
            '&:hover': { backgroundColor: "#C5415C" }
          }}
          onClick={handleOpen}
        >
          <img alt="Boton de añadir" width="55%" height="55%" src={anadirIcono} />
        </Fab>
      </Tooltip>
      {open && (
        <ModalGeneral
          Contenido={<AgregarDifusion onClose={handleClose} />}
          open={open}
          onClose={handleClose}
        />
      )}
    </>
  );
}